// Re-fetch the page-frame when the browser's back/forward buttons change
// the URL.
//
// Turbo.session.drive is disabled globally (see packs/glassfrog.js), but the
// layout wraps page content in a turbo-frame with data-turbo-action="advance".
// That makes frame navigations push history entries, so the URL bar updates
// when a user clicks into a nested page. Without Drive, however, Turbo's own
// popstate handler never restores frame content — so pressing back leaves the
// URL showing the previous page but the frame still showing the current one.
//
// Resetting frame.src on popstate causes Turbo to fetch the URL and swap the
// frame content to match, restoring expected back/forward behavior. OrgNav
// pages manage their own history via React Router and are skipped.
function setupPageFramePopstate() {
  window.addEventListener('popstate', () => {
    const frame = document.getElementById('page-frame')
    if (!frame)
      return
    if (window.location.pathname.includes('/orgnav/'))
      return
    frame.src = window.location.href
  })
}

export default {setupPageFramePopstate}
